<template>
  <li>
    <a
      href="#"
      @click.stop.prevent="$emit('click', dot.id)"
      class="flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6"
    >
      <div class="flex items-center truncate space-x-3">
        <span
          :class="{ 'bg-blue-100': isAssignedToCurrentUser }"
          class="flex-shrink-0 h-4 w-4 rounded-full flex items-center justify-center"
        >
          <span
            :class="[dotBgColor, dotOpacity]"
            class="h-2 w-2 rounded-full"
          ></span>
        </span>
        <p class="font-medium truncate text-sm leading-6">
          {{ card.name }}
          <span v-if="card.list" class="truncate font-normal text-gray-500"
            >in {{ card.list.name }}</span
          >
          <span v-if="card.priority" class="ps-px-3 ps-text-xxs">
            <span
              :class="[generateColors(card.priority.icon_color)]"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4"
              >{{ card.priority.name }}</span
            >
          </span>
        </p>
      </div>
      <svg
        class="ml-4 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </a>
  </li>
</template>

<script>
import ItemCardMixin from '@/mixins/item-card'

export default {
  name: 'ItemCardList',
  mixins: [ItemCardMixin]
}
</script>
